import { render, staticRenderFns } from "./mss-workout-description.component.vue?vue&type=template&id=0ac92fc0&scoped=true"
import script from "./mss-workout-description.component.ts?vue&type=script&lang=ts&external"
export * from "./mss-workout-description.component.ts?vue&type=script&lang=ts&external"
import style0 from "./mss-workout-description.component.scss?vue&type=style&index=0&id=0ac92fc0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac92fc0",
  null
  
)

export default component.exports